const navContainer = document.querySelector(".nav-container");
const initResize = () => {
    const winW = window.innerWidth;
    const winH = window.innerHeight;
    const winT = window.pageYOffset;
    if (winT >= 20) {
        navContainer.classList.add("active");
    } else {
        navContainer.classList.remove("active");
    }
};

window.addEventListener("resize", () => {
    initResize();
});

window.addEventListener("scroll", () => {
    initResize();
});

const pathname = document.location.pathname;

switch (pathname) {
    case "/login":
        navContainer.classList.add("active");
        break;
    case "/password/expired":
        navContainer.classList.add("active");
        break;
    case "/admin/login":
        navContainer.classList.add("active");
        break;
}

const lnbOnBtn = document.querySelector(".lnb-on-btn");
const lnbBox = document.querySelector(".lnb-box");

lnbOnBtn.addEventListener("click", () => {
    lnbBox.style.display = "block";
    setTimeout(() => {
        lnbBox.classList.add("active");
    }, 10);
});

const lnbCloseBtn = document.querySelector(".lnb-box .close-btn");
lnbCloseBtn.addEventListener("click", () => {
    lnbBox.classList.remove("active");
    setTimeout(() => {
        lnbBox.style.display = "none";
    }, 300);
});

const lnbCurtain = document.querySelector(".lnb-box .curtain");
lnbCurtain.addEventListener("click", () => {
    lnbBox.classList.remove("active");
    setTimeout(() => {
        lnbBox.style.display = "none";
    }, 300);
});

const profileOnBtn = document.querySelector(".top-nav .profile-on-btn");
const loginBox = document.querySelector(".top-nav .login-box");
const logOutBox = document.querySelector(".top-nav .log-out-box");

//profileOnBtn.addEventListener("click", function() {
//    loginBox.classList.toggle("active");
//});

/*
document.querySelector("body").addEventListener("click", function(event) {
    if (
        event.target !== document.querySelector(".top-nav .profile-on-btn") &&
        event.target !== document.querySelector(".top-nav .profile-on-btn span")
    ) {
        loginBox.classList.remove("active");
    }
});
*/
